export class Invoice {
    constructor(invoice) {
        this.id = invoice.id;
        this.checkout_id           = invoice.checkout_id;
        this.customer_id           = invoice.customer_id;
        this.customer_name         = invoice.customer_name;
        this.customer_phone        = invoice.customer_phone;
        this.promotion_code        = invoice.promotion_code;
        this.redeem_id             = invoice.redeem_id;
        this.total_discount        = invoice.total_discount;
        this.has_tax               = invoice.has_tax;
        this.tax_price             = invoice.tax_price;
        this.total_before_discount = invoice.total_before_discount;
        this.total_after_discount  = invoice.total_after_discount;
        this.total_after_tax       = invoice.total_after_tax;
        this.payment_method        = invoice.payment_method;
        this.employee_id           = invoice.employee_id;
        this.employee_name         = invoice.employee_name;
        this.status                = invoice.status;
        this.created_at            = invoice.created_at;
        this.updated_at            = invoice.updated_at;
        this.invoice_details       = invoice.invoice_details ? this.getInvoiceDetails(invoice.invoice_details) : [];
    }

    getInvoiceDetails(arr) {
        let invoice_detail_arr = [];
        for(let i = 0; i < arr.length; i++) {
            invoice_detail_arr.push(new InvoiceDetail(arr[i]));
        }
        return invoice_detail_arr;
    }
}

class InvoiceDetail {
    constructor(invoice_detail) {
        this.id                    = invoice_detail.id;
        this.invoice_id            = invoice_detail.invoice_id;
        this.product_type          = invoice_detail.product_type;
        this.product_id            = invoice_detail.product_id;
        this.product_name          = invoice_detail.product_name;
        this.description           = invoice_detail.description;
        this.duration              = invoice_detail.duration;
        this.product_price         = invoice_detail.product_price;
        this.quantity              = invoice_detail.quantity;
        this.promotion_code        = invoice_detail.promotion_code;
        this.discount_price        = invoice_detail.discount_price;
        this.has_tax               = invoice_detail.has_tax;
        this.tax_price             = invoice_detail.tax_price;
        this.total_after_tax       = invoice_detail.total_after_tax;
        this.total_before_discount = invoice_detail.total_before_discount;
        this.total_after_discount  = invoice_detail.total_after_discount;
        this.detail                = invoice_detail.detail;
        this.payment_method        = invoice_detail.payment_method;
        this.employee_id           = invoice_detail.employee_id;
        this.employee_name         = invoice_detail.employee_name;
        this.status                = invoice_detail.status;
        this.created_at            = invoice_detail.created_at;
        this.updated_at            = invoice_detail.updated_at;
    }
}